



















import Vue from 'vue'
import { ValidationProvider } from "vee-validate"

export default Vue.extend({
  components: {
    ValidationProvider
  },
  $_veeValidate: {
    value() {
      return this.value;
    }
  },
  props: {
    value:String,
    placeholder:{
      type:String,
      default:'Search'
    },
    autocomplete: {
      type: String,
      default: 'off'
    },
  },
})
